import { createFileRoute } from '@tanstack/react-router'

import { VendorWorkspace } from '@/features/vendor/VendorWorkspace'

export const Route = createFileRoute('/app/vendors/$vendorId')({
  component: VendorRoute,
})

/**
 * One vendor a buyer has, reached by its id.
 *
 * No check of its own for who is asking, for the reason `app.briefs.index.tsx`
 * records: everything under `/app` is behind one gate that answers that
 * question for all of them, and two answers to it would be two redirects
 * racing. Whether this particular vendor is the buyer's is the server's
 * answer, and it is the same answer a vendor that does not exist gets.
 */
function VendorRoute() {
  const { vendorId } = Route.useParams()

  return (
    <VendorWorkspace
      // Keyed by the vendor, so navigating between two of them opens a stream
      // on the one now on screen rather than leaving the previous one running.
      key={vendorId}
      vendorId={vendorId}
    />
  )
}
